import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Settings"],
  endpoints: (builder) => ({
    getSettings: builder.query({
      query: (params = {}) => buildPagedListUrl("settings/", params),
      providesTags: ["Settings"],
    }),
    addSettings: builder.mutation({
      query: (newSettings) => ({
        url: "settings/",
        method: "POST",
        body: newSettings,
      }),
      invalidatesTags: ["Settings"],
    }),
    updateSettings: builder.mutation({
      query: ({ uid, ...updatedSettings }) => ({
        url: `settings/${uid}`,
        method: "PUT",
        body: updatedSettings,
      }),
      invalidatesTags: ["Settings"],
    }),
    deleteSettings: builder.mutation({
      query: (uid) => ({
        url: `settings/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Settings"],
    }),
  }),
});

export const {
  useGetSettingsQuery,
  useAddSettingsMutation,
  useUpdateSettingsMutation,
  useDeleteSettingsMutation,
} = settingsApi;
